export default class Toggle {

  constructor() {
    this.toggles = document.querySelectorAll('.toggle-btn');
    const self = this;

    if ( this.toggles.length ) {
      this.toggles.forEach(toggle => {
        toggle.addEventListener('change', self.httpReq.bind(this, toggle));
      });
    }

  }

  httpReq(toggle) {
    const { url, method, key } = toggle.dataset;

    $.ajax({
      url,
      type: method,
      data: {
        [key]: Number(toggle.checked),
      }
    });
  }
}
